module.exports = require('./backbone-events-standalone');



/** WEBPACK FOOTER **
 ** ./~/backbone-events-standalone/index.js
 **/